<template>
	<div>
		<div class="titleIcon">
			<div class="inlin">
				<i :class="`iconfont ${icon} tableIcon`"></i>
				<span class="fz14">{{title}}</span>
			</div>
		</div>
		<div class="portraitLine disflex" ref="breadcrumb">
			<div v-if="reportList&&reportList.length>0" ref="nationwide">
				<div class="echarts">
					<div :id="echarts" class="barchartsHeight" ref="echarts"></div>
				</div>
			</div>
			<div v-else class="echartsNull">
				<div>
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import echarts from 'echarts'
	export default {
		props: ['name', 'colorList', 'icon', 'title', 'reportList', 'chartsType','type','image'],
		data() {
			return {
				myChart: null,
				height: 25,
				barMaxWidth: 7,
				num: 0,
				data:[],
				value:[],
				minNumber:0
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList', 'GetReportListArr']),
			...Vuex.mapState('breadcrumb', ['reportScreening']),
			...Vuex.mapState('visualization', ['trigger','setDateArr','portiaitbreadcrumbList']),
			echarts() {
				return 'echarts' + this.getCode();
			}
		},
		watch: {
			reportList(old, news) {
				let _this = this;
				if (this.reportList) {
					this.trigger.hospital = false;
					this.$nextTick(() => {
						_this.update();
						_this.getEcharts();
					})
				}
			}
		},
		updated() {
			let _this = this;
			if (this.trigger.hospital) {
				this.trigger.hospital = false;
				this.$nextTick(() => {
					_this.update();
					_this.getEcharts();
				})
			}
		},
		mounted() {
			//左侧导航收起时右侧图联动
			let _this = this;
			this.$nextTick(() => {
				_this.update();
				_this.getEcharts();
			})
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					let dom = document.getElementById(_this.echarts);
					if (dom) {
						dom.style.width = _this.$refs.nationwide.offsetWidth - 40 + "px";
						_this.myChart.resize();
						_this.update();
						_this.getEcharts();
					}
				}
			})
		},

		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'setBreadcrumbList']),
			...Vuex.mapMutations('visualization',['setportiaitbreadcrumbList']),
			update(){
				let _this = this;
				_this.data = [];
				_this.value = [];
				if (this.reportList&&this.reportList.length > 0) {
					this.reportList.forEach(element => {
						let valueCount = '';
						// _this.data.push({
						// 	value: element.HospitalName
						// })
						_this.value.push({
							value: element.AvgScore,
							sampledNum: element.SampledNum,
							HospitalName: element.HospitalName,
							HospitalGuid: element.HospitalGuid
						})
					})
					let newarr = _this.value.sort((a, b) => { return Math.abs(a.value) - Math.abs(b.value) });
					this.minNumber = Math.floor(newarr[0].value/10)*10;
					_this.value = _this.value.map(item=>{
						item.value = item.value - _this.minNumber;
						return item;
					})
					_this.data = _this.value.map(item=>{
						return item.HospitalName;
					})
				} else {
					_this.data = [];
					_this.value = [];
				}
			},
			getCaption(obj) {
				var index = obj.lastIndexOf("\-");
				obj = obj.substring(index + 1, obj.length);
				return obj.replace(/\b(0+)/gi, "");
			},
			reportClick(item, index) {
				this.num = index;
				this.$emit(this.name, item)
			},
			getEcharts() {
				let _this = this;
				let rotate = 0;
				if (this.reportList.length<=4) {
					rotate = 0;
				}else{
					rotate = 30;
				}
				let color = [_this.colorList[0]];
				let dom = document.getElementById(_this.echarts);
				this.height = 14.5;
				this.barMaxWidth = 7;
				if (dom) {
					dom.style.width = this.$refs.breadcrumb.offsetWidth + "px";
					dom.style.height = this.$refs.breadcrumb.offsetHeight - 15 + "px";
					this.myChart = echarts.init(dom);
				}
				let app = {};
				let option = null;
				option = {
					color: color,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
						formatter: function(params, ticket, callback) {
							return "平均分: "+ (params[0].data.value + _this.minNumber)+"分<br/>报告数: "+params[0].data.sampledNum+"份";
						},
					},
					grid: {
						left: 20,
						right: 10,
						bottom: 0,
						height: "76%",
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: _this.data,
						triggerEvent: true,
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							rotate:rotate,
							interval: 0,
							textStyle: {
								color: '#ffffff',
								fontSize: 8
							}
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff',
								fontSize: 8
							},
							formatter (value) {
							  return value + _this.minNumber
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [{
						barMaxWidth: this.barMaxWidth,
						name: '医生',
						barMinHeight: 10,
						type: _this.chartsType,
						itemStyle: {
							normal: {
								barBorderRadius: [20, 20, 20, 20],
								color: new echarts.graphic.LinearGradient(
									0, 0, 1, 1,
									[{
											offset: 0,
											color: _this.colorList[1]
										}, //柱图渐变色
										{
											offset: 1,
											color: _this.colorList[0]
										}, //柱图渐变色
									]
								)
							}
						},
						data: _this.value,
						symbol: 'none',
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0.5,
									color: _this.colorList[0]
								}, {
									offset: 1,
									color: 'RGBA(255, 255, 255, .3)'
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				if (option && typeof option === "object"&&this.myChart) {
					this.myChart.clear()
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						let HospitalName = params.data.HospitalName;
						let hospitalGuid = params.data.HospitalGuid;
						this.setTootipType(false);
						this.clearRow();
						this.currentChangesSecond(1);
						this.setportiaitbreadcrumbList();
						this.portiaitbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
						this.GetReportListArr.type = HospitalName;
						this.portiaitbreadcrumbList.push(HospitalName);
						this.portiaitbreadcrumbList.push('portrait');
						this.GetReportListArr.name = HospitalName;
						this.GetReportListArr.hospitalGuid = hospitalGuid;
						this.$router.push("/home/visualization/visImageCenter");
					});

					this.myChart.resize(); //区域更新
					window.addEventListener("resize", () => {
						this.myChart.resize();
					});
				}
			}
		}

	}
</script>
